// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2zCxN","sendOtp":"AuthorizeToLogin_sendOtp__w3YP3"};